<template>
    <div class="composition">
      <Search :title="name" :total="total">
        <div style="background: #fff">
          <div class="map">
            <div class="round americas" :style="{transform: `scale(${americas * 5 / 80} )`}">
              <span>美洲:{{americas}}%</span>
            </div>
            <div class="round europe" :style="{transform: `scale(${europe * 5 / 80} )`}">
              <span>欧洲:{{europe}}%</span>
            </div>
            <div class="round e_asia" :style="{transform: `scale(${e_asia * 5 / 80} )`}">
              <span>东亚:{{e_asia}}%</span>
            </div>
            <div class="round africa" :style="{transform: `scale(${africa * 5 / 80} )`}">
              <span>非洲:{{africa}}%</span>
            </div>
            <div class="round s_asia" :style="{transform: `scale(${s_asia * 5 / 80} )`}">
              <span>南亚:{{s_asia}}%</span>
            </div>
          </div>
        </div>
        <div class="detail" v-for="(item, index) in data" :key="index">
          <div style="width: 90%">
            <span class="dot"></span>
            <span class="area">{{item[0].state}}</span>
            <span class="total" v-if="item[0].state === '东亚'">{{e_asia.toFixed(2)}}%</span>
            <span class="total" v-if="item[0].state === '美洲'">{{americas.toFixed(2)}}%</span>
            <span class="total" v-if="item[0].state === '欧洲'">{{europe.toFixed(2)}}%</span>
            <span class="total" v-if="item[0].state === '非洲'">{{africa.toFixed(2)}}%</span>
            <span class="total" v-if="item[0].state === '南亚'">{{s_asia.toFixed(2)}}%</span>
          </div>
          <ul>
            <li v-for="item1 in item" :key="item1.eid">
              <span>{{item1.name}}</span>
              <span>{{item1.rate}}%</span>
            </li>
          </ul>
        </div>
      </Search>
    </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'composition',
  data () {
    return {
      name: '祖源成分',
      total: '',
      data: [],
      e_asia: 0,
      americas: 0,
      europe: 0,
      africa: 0,
      s_asia: 0
    }
  },
  methods: {
    scale () {
      // 缩放比例 = 百分比 * x / 80
      let round = document.getElementsByClassName('round')
      for (let i = 0; i < round.length; i++) {
        let transform = getComputedStyle(round[i], null)['transform']
        let scale = parseFloat(transform.substring(7).split(',')[3])
        if (scale > 1.75) {
          round[i].style.transform = 'scale(1.2)'
        }
        if (scale < 0.375) {
          round[i].style.transform = 'scale(0.375)'
        }
        if (scale < 0.35) {
          // round[i].getElementsByTagName('span')[0].style.display = 'none'
        }
        if (scale === 0) {
          round[i].style.transform = 'scale(0.2)'
          round[i].getElementsByTagName('span')[0].style.display = 'none'
        }
      }
    },
    items () {
      this.util.get(this.api.items, '', (success) => {
        this.total = success.max_rate + success.max_name
        this.data = success.items
        let eAsia = []
        let eSsia = []
        let europe = []
        let americas = []
        let africa = []
        success.items['东亚'].forEach(item => {
          eAsia.push(item.rate)
        })
        success.items['南亚'].forEach(item => {
          eSsia.push(item.rate)
        })
        success.items['欧洲'].forEach(item => {
          europe.push(item.rate)
        })
        success.items['美洲'].forEach(item => {
          americas.push(item.rate)
        })
        success.items['非洲'].forEach(item => {
          africa.push(item.rate)
        })
        this.e_asia = this.floatAdd(eAsia)
        this.s_asia = this.floatAdd(eSsia)
        this.europe = this.floatAdd(europe)
        this.americas = this.floatAdd(americas)
        this.africa = this.floatAdd(africa)
        this.$nextTick(() => {
          this.scale()
        })
      })
    },
    // 小数点加法运算
    floatAdd (arr) {
      let args = arr // 获取所有的参数
      let d = 0 // 定义小数位的初始长度，默认为整数，即小数位为0
      let sum = 0 // 定义sum来接收所有数据的和
      // 循环所有的参数
      for (let key in args) { // 遍历所有的参数
        // 把数字转为字符串
        var str = '' + args[key]
        if (str.indexOf('.') !== -1) { // 判断数字是否为小数
          // 获取小数位的长度
          var temp = str.split('.')[1].length
          // 比较此数的小数位与原小数位的长度，取小数位较长的存储到d中
          d = d < temp ? temp : d
        }
      }
      // 计算需要乘的数值
      let m = Math.pow(10, d)
      // 遍历所有参数并相加
      for (var key in args) {
        sum += args[key] * m
      }
      // 返回结果
      return sum / m
    }
  },
  mounted () {
    this.items()
  },
  components: {
    Search
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .detail {
    padding: pxToRem(20px);
    background: #fff;

    .dot {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }

    .area {
      font-size: pxToRem(30px);
      font-weight: bold;
      margin-left: pxToRem(20px);
    }

    .total {
      font-size: pxToRem(30px);
      font-weight: bold;
      float: right;
    }

    ul {
      width: 80%;
      margin: pxToRem(20px) auto;

      li {
        padding: pxToRem(10px) 0;

        span:last-child {
          float: right;
        }
      }
    }
  }
  .detail:nth-of-type(2) .dot{
    background: rgba(124,73,139,0.7);
  }
  .detail:nth-of-type(3) .dot{
    background: rgba(32,154,198,0.7);
  }
  .detail:nth-of-type(4) .dot{
    background: rgba(47,187,146,0.7);
  }
  .detail:nth-of-type(5) .dot{
    background: rgba(212,174,52,0.7);
  }
  .detail:nth-of-type(6) .dot{
    background: rgba(115,169,61,0.7);
  }
</style>
<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .map {
    position: relative;
    width: 100%;
    height: pxToRem(400px);
    margin: 0 auto pxToRem(20px) ;
    background: url('../../assets/images/source/map.png') no-repeat;
    background-size: 100% 100%;
    font-size: pxToRem(14px);
    color: #fff;
    text-align: center;
  }
  .round {
    width: pxToRem(150px);
    height: pxToRem(150px);
    line-height: pxToRem(150px);
    border-radius: 50%;
    position: absolute;
  }
  .americas {
    top: pxToRem(120px);
    right: pxToRem(100px);
    background: rgba(32,154,198,0.7);
    transform: scale(0.6);
  }
  .europe {
    top: pxToRem(40px);
    left: pxToRem(0px);
    background: rgba(47,187,146,0.7);
    transform: scale(0.4);
  }
  .e_asia {
    top: pxToRem(80px);
    left: pxToRem(220px);
    background: rgba(124,73,139,0.7);
    transform: scale(0.9);
  }
  .africa {
    top: pxToRem(200px);
    left: pxToRem(20px);
    background: rgba(212,174,52,0.7);
    transform: scale(0.3);
  }
  .s_asia {
    top: pxToRem(240px);
    left: pxToRem(330px);
    background: rgba(115,169,61,0.7);
    transform: scale(0.375);
  }
</style>



// WEBPACK FOOTER //
// src/views/source/composition.vue